// Generated by purs version 0.14.4
import * as Effect_Unsafe from "../Effect.Unsafe/index.js";
import * as Specular_Internal_Incremental_Ref from "../Specular.Internal.Incremental.Ref/index.js";
var stabilizationIsNotInProgress = -1 | 0;
var globalTotalRefcount = Effect_Unsafe.unsafePerformEffect(function () {
    return Specular_Internal_Incremental_Ref["new"](0);
});
var globalLastStabilizationNum = Effect_Unsafe.unsafePerformEffect(function () {
    return Specular_Internal_Incremental_Ref["new"](0);
});
var globalCurrentStabilizationNum = Effect_Unsafe.unsafePerformEffect(function () {
    return Specular_Internal_Incremental_Ref["new"](stabilizationIsNotInProgress);
});
export {
    stabilizationIsNotInProgress,
    globalLastStabilizationNum,
    globalCurrentStabilizationNum,
    globalTotalRefcount
};
//# sourceMappingURL=index.js.map
